let _ = require("ES/lib/lodash");
let esUtils = require("ES/utils/esUtils");

let buildSessions = function(n_sess, old_sessions){
	let new_sessions = _.values(old_sessions);//ensuring it's an array

	let has_data_loss = false;

	let n_sess_diff = n_sess - _.size(new_sessions);

	if(n_sess_diff === 0){//no change
		//nothing to do
	}else if(n_sess_diff > 0){
		//add some more
		_.each(_.range(0, n_sess_diff), function(s){
			new_sessions.push({id: -1});//-1 means create a new one
		});
	}else{
		//TODO cherry pick the blank ones (not checked or blank date)
		//TODO indicate that data was lost
		has_data_loss = true;
		new_sessions = _.take(new_sessions, n_sess);
	}
	return {new_sessions, has_data_loss};
};

let isTeamPart = function(part){
	return esUtils.toInt(part.id) === 0;
};

module.exports = function(numbers, old_VideoCoaching){
	let {PARTICIPANTS, INDIVIDUAL_SESSIONS, TEAM_SESSIONS} = numbers;

	let has_data_loss = false;

	//put the old participants at the top
	let new_VideoCoaching = _.reject(old_VideoCoaching, isTeamPart);

	let n_part_diff = PARTICIPANTS - _.size(new_VideoCoaching);
	if(n_part_diff === 0){
		//nothing to do
	}else if(n_part_diff > 0){
		//add some more
		_.each(_.range(0, n_part_diff), function(){
			new_VideoCoaching.push({id: -1});//-1 means create a new one (0 means team)
		});
	}else{
		//TODO cherry pick the blank ones (not checked or blank date)
		has_data_loss = true;
		new_VideoCoaching = _.take(new_VideoCoaching, PARTICIPANTS);
	}

	//Add the team sessions at the end
	let old_team = _.find(old_VideoCoaching, isTeamPart);
	if(old_team){
		new_VideoCoaching.push(old_team);
	}else{
		new_VideoCoaching.push({id: 0});//0 for team session
	}

	//Adjust the number of sessions for all these parts
	new_VideoCoaching = _.map(new_VideoCoaching, function(part){
		let n_sess = isTeamPart(part) ? TEAM_SESSIONS : INDIVIDUAL_SESSIONS;

		let d = buildSessions(n_sess, part.sessions);
		has_data_loss = has_data_loss || d.has_data_loss;
		return _.assign({}, part, {
			sessions: d.new_sessions
		});
	});

	return {
		has_data_loss,
		VideoCoaching: new_VideoCoaching
	};
};



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/coaching/buildNDiffVideoCoaching.js